<main-layout>
  <div class="py-8 px-6 mx-auto max-w-screen-xl lg:px-4">
    {{getUserInfo}}
  </div>
</main-layout>